export default class EditableButton {
  constructor (scene, x, y, text, value, callback, index) { // }, text, callback) {
    this.scene = scene
    this.callback = callback
    this.textOffsetX = 5
    this.textOffsetY = 20
    this.value = value
    this.index = index

    var config = {
      fontSize: '20px',
      fontStyle: 'bold'
    }

    this.text = this.scene.add.text(x + this.textOffsetX, y + this.textOffsetY, text, config)
    this.text.setVisible(false)
    this.text.setDepth(1001)

    this.image = this.scene.add.image(x, y, 'white')
    this.image.setOrigin(0, 0)
    this.image.setScale(200, 50)
    this.image.setTint(0xFF0000)
    this.image.setDepth(1000)
    this.image.setInteractive()
    this.image.input.alwaysEnabled = true
    this.image.on('pointerover', () => { this.image.setTint(0xFF7700) })
    this.image.on('pointerout', () => { this.image.setTint(0xFF0000) })

    this.inputField = this.scene.add.dom(x, y, 'input', {
      background: 'transparent',
      border: 0,
      color: 'white',
      fontSize: '20pt',
      fontWeight: 'bold',
      fontFamily: 'Courier',
      outline: 'none',
      textAlign: 'right'
    }).setOrigin(0, 0)
    this.inputField.node.size = 9
    this.inputField.node.value = this.value.toString()
    this.inputField.node.addEventListener('keydown', (el) => {
      if (el.key === 'Enter') {
        this.value = parseFloat(el.target.value)
        if (isNaN(this.value)) {
          this.value = el.target.value.toLowerCase().trim() === 'true'
        }
        this.callback(this.index, this.value)
      }
    })

    this.inputField.node.onfocus = () => { this.inputField.node.value = this.value.toString() }
    this.inputField.node.onblur = () => { this.inputField.node.value = this.value.toString() }
  }

  destroy () {
    this.text.destroy()
    this.image.destroy()
    this.inputField.destroy()
  }

  hide () {
    this.text.setVisible(false)
    this.image.setVisible(false)
    this.inputField.setVisible(false)
    this.image.disableInteractive()
  }

  unhide (x, y) {
    this.setX(x)
    this.setY(y)
    this.text.setVisible(true)
    this.image.setVisible(true)
    this.inputField.setVisible(true)
    this.image.setInteractive()
  }

  setX (x) {
    this.text.x = x + this.textOffsetX
    this.image.x = x
    this.inputField.x = x + 50
  }

  setY (y) {
    this.image.y = y
    this.text.y = y + this.textOffsetY
    this.inputField.y = y + this.textOffsetY / 2
  }
}
